module.exports = __webpack_public_path__ + "static/media/person-4-full.e737ddd7.png";